import {SvgIcon, useTheme} from '@mui/material';

export default function CloseIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[900] : theme.palette.primary[50];
	
	return (
		<SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
			<mask id="mask0_1436_3153" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24"
			      height="24">
				<rect width="24" height="24" fill="#D9D9D9"/>
			</mask>
			<g mask="url(#mask0_1436_3153)">
				<path
					d="M11.9999 13.05L6.9249 18.125C6.79157 18.2584 6.6209 18.329 6.4129 18.337C6.20424 18.3457 6.0249 18.275 5.8749 18.125C5.7249 17.975 5.6499 17.8 5.6499 17.6C5.6499 17.4 5.7249 17.225 5.8749 17.075L10.9499 12L5.8749 6.92502C5.74157 6.79169 5.6709 6.62069 5.6629 6.41202C5.65424 6.20402 5.7249 6.02502 5.8749 5.87502C6.0249 5.72502 6.1999 5.65002 6.3999 5.65002C6.5999 5.65002 6.7749 5.72502 6.9249 5.87502L11.9999 10.95L17.0749 5.87502C17.2082 5.74169 17.3792 5.67069 17.5879 5.66202C17.7959 5.65402 17.9749 5.72502 18.1249 5.87502C18.2749 6.02502 18.3499 6.20002 18.3499 6.40002C18.3499 6.60002 18.2749 6.77502 18.1249 6.92502L13.0499 12L18.1249 17.075C18.2582 17.2084 18.3289 17.379 18.3369 17.587C18.3456 17.7957 18.2749 17.975 18.1249 18.125C17.9749 18.275 17.7999 18.35 17.5999 18.35C17.3999 18.35 17.2249 18.275 17.0749 18.125L11.9999 13.05Z"
					fill={color}/>
			</g>
		</SvgIcon>
	);
}
